import { qspost} from '@/plugins/axios'
import {REQUEST_TYPE_FW} from "@/config";


/*
 * 意见反馈
 * */
export const feedback = (phone,content,source = 3) => qspost('/home/index/feedback', {
    phone,content,source
},REQUEST_TYPE_FW)
/*
 * 添加部门
 * */
export const addDepartment = (title) => qspost('/Home/Team/addDepartment', {title},REQUEST_TYPE_FW)

/*
 * 部门列表
 * */
export const listDepartment = () => qspost('/Home/Team/listDepartment', {},REQUEST_TYPE_FW)

/*
 * 部门人员列表
 * */
export const orgEmployeeList = (searchName,searchPhone) => qspost('/Home/Team/orgEmployeeList', {searchName,searchPhone},REQUEST_TYPE_FW)

/*
 * 添加部门人员
 * */
export const addEmployee = (phone,name,sex,education,birthday,inductionTime,
                            zhiwu,bumen,pass) => qspost('/Home/Team/addEmployee', {phone,name,sex,education,birthday,inductionTime,
    zhiwu,bumen,pass},REQUEST_TYPE_FW)

/*
 * 修改人员
 * */
export const editEmployee = (userId,phone,name,sex,education,birthday,inductionTime
    ,zhiwu,bumen,pass) => qspost('/Home/Team/editEmployee', {userId,phone,name,sex,education,birthday,inductionTime
    ,zhiwu,bumen,pass},REQUEST_TYPE_FW)

/*
 * 删除人员
 * */
export const delEmployee = (id) => qspost('/Home/Team/delEmployee', {id},REQUEST_TYPE_FW)

/*
 * 初始化密码
 * */
export const resetPass = (id,pass) => qspost('/Home/Team/resetPass', {id,pass},REQUEST_TYPE_FW)

/*
 * 移动人员
 * */
export const moveEmployee = (id,zhiwu,bumen) => qspost('/Home/Team/moveEmployee', {id,zhiwu,bumen},REQUEST_TYPE_FW)

/*
 * 删除部门
 * */
export const delDepartment = (id) => qspost('/Home/Team/delDepartment', {id},REQUEST_TYPE_FW)

/*
 * 获取自定义模块
 * */
export const contentTypeList = () => qspost('/organization/Organization/contentTypeList', {})

/*
 * 添加自定义模块
 * */
export const createContentType = (typeName) => qspost('/organization/Organization/createContentType', {typeName})

/*
 * 删除自定义板块
 * */
export const contentTypeDel = (typeId) => qspost('/organization/Organization/contentTypeDel', {typeId})

/*
 *  文章内容 -- 添加/修改 -- 用于指定板块
 * */
export const createTypeContentAppoint = (typeId,title,content) => qspost('/organization/Organization/createTypeContentAppoint', {typeId,title,content})

/*
 *  文章内容 -- 添加/修改 -- 用于自定义板块
 * */
export const createTypeContent = (typeId,title,content) => qspost('/organization/Organization/createTypeContent', {typeId,title,content})

/*
 *  获取文章详情 -- 用于指定板块
 * */
export const contentShowAppoint = (typeId) => qspost('/organization/Organization/contentShowAppoint', {typeId})

/*
 *  获取文章详情 -- 用于自定义板块
 * */
export const contentShow = (typeId) => qspost('/organization/Organization/contentShow', {typeId})

/*
 *  获取文章详情 -- 用于自定义板块
 * */
export const getOrgTypeContentAll = () => qspost('/organization/Organization/getOrgTypeContentAll', {})

/*
 *  消息
 * */
export const messageList = () => qspost('/organization/Message/messageList', {})


/*
 * 获取版本更新
 * */
export const getInfo = () => qspost('/Index/Iterative/getInfo', {})
/*
 * 迭代通知不再提醒
 * */
export const noRemind = (id) => qspost('/Index/Iterative/noRemind', {id})

/*
 * 使用说明
 * */

export const getHelpList = (enum_num) => qspost('Index/Help/getInfo', {enum_num})

